import { Grid, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Layout from "../../components/Layout";
import LoadingComponent from "../../components/LoadingComponent";
import { GlobalContext } from "../../contexts/GlobalContext";
import { format, parse } from "date-fns";
import NoData from "../../components/NoData";

 function OtherTransactions () {

    const { url, phone, setPhone, contact, setContact, customer, setCustomer, customerName, setCustomerName, token, setToken, portal  } = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);

    const [items, setItems] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        setLoading(true)
        setItems([]);
        setHasMore(true);
        setCurrentPage(1);
        fetchData(1);
    }, [])

    function fetchData (page) {
        axios.post( url + 'api/transaction?page=' + page, {
            buyer: (portal === "buyer") ? customer : "",
            supplier: (portal === "supplier") ? customer : "",            
        }, { headers: { Authorization: `Bearer ${token}` }})
        .then(function (response) {
            console.log({response})
            setLoading(true)
            setItems((prev) => [...prev, ...response.data.data]);
            setCurrentPage(parseInt(response.data.current_page));
            setHasMore(response.data.current_page !== response.data.last_page);
            setLoading(false)
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    const Items = ({item}) => {
        console.log({item})
        return (
            <>
            <Paper sx={{ border: 1, borderColor: 'divider', cursor: 'pointer', width: '100%', maxWidth: '100%', textAlign: 'center', mt: 4 }}>
                <Grid container>
                    <Grid item xs={12} sx={{ borderRight: 1, borderBottom: 1, borderColor: 'divider', px: 1, py:1 }}>
                        <Typography variant="overline" component="p">{portal === "buyer" ? "Supplier" : "Buyer"}</Typography>
                        <Typography variant="body" component="p">{(portal === "buyer" ? item?.seller_details?.name: item?.buyer_details?.name) || "Not Available"}</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ borderRight: 1, borderBottom: 1, borderColor: 'divider', px: 1, py:1 }}>
                        <Typography variant="overline" component="p">Date</Typography>
                        <Typography variant="body" component="p">{item?.date ? format(parse(item?.date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : 'Not Available'}</Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ borderRight: 1, borderBottom: 1, borderColor: 'divider', px: 1, py:1 }}>
                        <Typography variant="overline" component="p">Amount</Typography>
                        <Typography variant="body" component="p">{ `\u20B9 ${item?.amount}` || "Not Available" }</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ borderRight: 1, borderBottom: 1, borderColor: 'divider', px: 1, py:1 }}>
                        <Typography variant="overline" component="p">Narration</Typography>
                        <Typography variant="body" component="p"   >{item?.narration || "Not Available"}</Typography>                        
                    </Grid>
                </Grid>
            </Paper>
            </>
        )
    }

    

    return (
        <>
        {  loading ? 
            <LoadingComponent loading={loading} />
            :
            <>
            <Layout title={"Other Transactions"}>
                <Box>
                    {(items?.length !== 0) ?
                        <InfiniteScroll scrollThreshold={0.5} dataLength={items.length} next={() => fetchData(currentPage + 1)} style={{ display: 'flex', flexDirection: 'column' }} inverse={false} hasMore={hasMore} loader={<p style={{ textAlign: 'center', fontSize: '14px' }}>Loading...</p>} endMessage={ items.length !== 0 ? <p style={{ textAlign: 'center', fontSize: '14px' }}>You have reached end of the list</p> : <></>}>
                            {items?.length != 0 && items.map((item, index) => { return <Items item={item} key={index} /> })}
                        </InfiniteScroll>
                        :
                        <NoData />
                    }
                </Box>
            </Layout>
            </>
        }        
        </>
    )
 }

 export default OtherTransactions;